import React from 'react'
import { PopupTooltip, Icon } from '@adc/ui-morpheus'

interface UserValueProps {
  email?: string
  display_name?: string
  nullDisplay: string
}

const UserValue: React.FC<UserValueProps> = ({
  email,
  display_name,
  nullDisplay,
}) => (
  <>
    <span>{email + ' ' || nullDisplay}</span>
    {email && (
      <PopupTooltip
        on='hover'
        offset={-1}
        horizontalOffset={undefined}
        verticalOffset={undefined}
        trigger={
          <Icon
            color='grayMedium'
            iconStyle='solid'
            name='info-circle'
            fitted
            size='small'
            style={{ verticalAlign: 'text-top' }}
          />
        }
        content={<span>{display_name || 'Unspecified'}</span>}
      />
    )}
  </>
)

export default UserValue
